_.clean = object => {
  return _.omitBy(object, value => {
    if (_.isArray(value)) {
      return _.isEmpty(value)
    } else if (_.isString(value)) {
      return value === ''
    } else {
      return false
    }
  })
}
